// extracted by css-extract-rspack-plugin
export default {"tabs-underline":"tabs-underline-RnzQHm","tabsUnderline":"tabs-underline-RnzQHm"};